import {
    ACCOUNT_RECEIVABLE_LIST,
    ALL_OFFERS_EXCLUDING_JOINGING_PENDING_LIST,
    ALL_OFFERS_EXCLUDING_JOINGING_PENDING_LIST_NO_PAGINATION,
    FETCH_ACCOUNT_CONSULTANT_LIST_SUCCESS,
    FETCH_ACCOUNT_CONSULTANT_OBJECT_SUCCESS,
    FETCH_ACCOUNT_CONSULTANT_OFFER_LIST_SUCCESS,
    FETCH_ACCOUNT_CONSULTANT_ON_OFFERS_LIST_SUCCESS,
    FETCH_ACCOUNT_OFFER_BY_YEAR_LIST_SUCCESS,
    FETCH_ACCOUNT_OFFER_CONSULTANT_PAYEE_LIST_SUCCESS,
    FETCH_ACCOUNT_PAYROLL_DETAILS_SUCCESS,
    FETCH_ACCOUNT_SUPPORT_OFFER_LIST_SUCCESS,
    FETCH_APPROVED_HOURS_LIST_SUCCESS,
    FETCH_CLOSED_ACCOUNT_OFFER_LIST_SUCCESS,
    FETCH_INVOICE_NUMBER_LIST_SUCCESS,
    FETCH_MISSING_TIMESHEET_DETAILS_SUCCESS,
    FETCH_MISSING_TIMESHEET_LIST_SUCCESS,
    FETCH_ONGOING_ACCOUNT_OFFER_LIST_SUCCESS,
    FETCH_PAYROLL_CACHE_LIST_SUCCESS,
    FETCH_REIMBURSEMENT_LIST_SUCCESS,
    FETCH_SINGLE_ACCOUNT_RECEIVABLE_DATA,
    FETCH_TRANSACTION_LIST_SUCCESS,
    FETCH_TRANSATION_LIST_FROM_INVOICE_NUMBER,
    FETCH_TRANSATION_LIST_TO_DOWNLOAD,
  } from "../../constants/ActionTypes";
  
  import {fetchError, fetchStart, fetchSuccess, handleErrorResponse, handleRemoveDisableSubmitButton, showMessage} from "./Common";
  import { ADD_REIMBURSEMENT, CREATE_PAYROLL_CACHE, DELETE_TRANSACTION_LIST, EDIT_ACCOUNT_RECEIVABLE_DATA, EDIT_ACCOUNTS_OFFERS, Edit_REIMBURSEMENT, Edit_REIMBURSEMENT_STATUS, GENERATE_PAYROLL, GET_ACCOUNT_CONSULTANT, GET_ACCOUNT_CONSULTANT_LIST, GET_ACCOUNT_CONSULTANT_OFFERS, GET_ACCOUNT_CONSULTANT_OFFERS_ASSIGNED_PAYEE_LIST, GET_ACCOUNT_OFFER_BY_YEAR_LIST, GET_ACCOUNT_PAYROLL_DETAILS, GET_ACCOUNT_RECEIVABLE_LIST, GET_ACCOUNT_SUPPORT_OFFERS, GET_ALL_OFFERS_EXCLUDING_JOINGING_PENDING, GET_APPROVED_HOURS, GET_CONSULTANT_OFFERS, GET_CONSULTANT_ON_OFFERS_LIST, GET_INVOICE_NUMBER_LIST, GET_MISSING_TIMESHEET_DETAILS, GET_MISSING_TIMESHEET_LIST, GET_PAYROLL_CACHE, GET_PAYROLL_CACHE_FOR_ALL, GET_SIGNLE_ACCOUNT_RECEIVABLE_DATA, GET_TRANSACTION_LIST, GET_TRANSATION_LIST_FROM_INVOICE_NUMBER, GET_TRANSATION_LIST_TO_DOWNLOAD, SEND_CONSULTANT_INVOICE_APPROVE_MAIL, UPDATE_TRANSACTION_LIST } from "../../constants/ApiEndpoints";
  import {userService} from "../services";
import { message } from "antd";

const fetchAccountReceivableListSuccess = (response) => {
    return{
        type: ACCOUNT_RECEIVABLE_LIST,
        payload: response
    }
}

export const fetchAccountReceivableList = (filterBy={page:1 }) => {
    return (dispatch) => {
        dispatch(fetchStart());
        userService.get(GET_ACCOUNT_RECEIVABLE_LIST,filterBy).then((response) => {
        if (response) {
            dispatch(fetchAccountReceivableListSuccess(response));
            dispatch(fetchSuccess());
        }
        }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
        });
    }
};

export const AddAccountReceivable = (filterBy={value:null ,currentPage:1}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        userService.post(GET_ACCOUNT_RECEIVABLE_LIST,filterBy.value).then((response) => {
        if (response) {
            dispatch(fetchSuccess());
            dispatch(handleRemoveDisableSubmitButton('add_account_receivable'))
            dispatch(fetchAccountReceivableList({page: filterBy.currentPage}));
            dispatch(showMessage('Successful!'))
            dispatch(handleErrorResponse({"add_account_receivable": "success"}))
        }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
            dispatch(handleRemoveDisableSubmitButton('add_account_receivable'))
            dispatch(handleErrorResponse({"add_account_receivable": error}))
        });
    }
};

const fetchAllOffersOtherThenJoiningPendingOffersSuccess = (response) => {
    return{
        type: ALL_OFFERS_EXCLUDING_JOINGING_PENDING_LIST,
        payload: response
    }
}

const fetchAllOffersOtherThenJoiningPendingNoPagination = (response) => {
    return{
        type: ALL_OFFERS_EXCLUDING_JOINGING_PENDING_LIST_NO_PAGINATION,
        payload: response
    }
}

export const fetchAllOffersExcludingJoingingPending = (filterBy={page:1, pagination:true}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        userService.get(GET_ALL_OFFERS_EXCLUDING_JOINGING_PENDING,filterBy).then((response) => {
        if (response) {
            if(filterBy.pagination === false){
                dispatch(fetchAllOffersOtherThenJoiningPendingNoPagination(response));
            }else{
                dispatch(fetchAllOffersOtherThenJoiningPendingOffersSuccess(response));
            }
            dispatch(fetchSuccess());
        }
        }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
        });
    }
};

const fetchSingleAccountReceivableDataSuccess = (response) => {
    return{
        type: FETCH_SINGLE_ACCOUNT_RECEIVABLE_DATA,
        payload: response
    }
}


export const fetchSingleAccountReceivableData = (filterBy={accountReceivableId: null}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        const andPoint = GET_SIGNLE_ACCOUNT_RECEIVABLE_DATA.replace('receivablesId',filterBy.accountReceivableId)
        userService.get(andPoint).then((response) => {
        if (response) {
            dispatch(fetchSingleAccountReceivableDataSuccess(response));
            dispatch(fetchSuccess());
        }
        }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
        });
    }
};

export const editAccountReceivable = (filterBy={accountReceivableId: null, value: null, currentPage:1}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        const andPoint = EDIT_ACCOUNT_RECEIVABLE_DATA.replace('receivablesId',filterBy.accountReceivableId)
        userService.patch(andPoint,filterBy.value).then((response) => {
        if (response) {
            dispatch(fetchSuccess());
            dispatch(fetchAccountReceivableList({page:filterBy.currentPage}))
            dispatch(handleRemoveDisableSubmitButton('edit_account_receivable'))
            dispatch(showMessage('Successful!'))
            dispatch(handleErrorResponse({"edit_account_receivable": 'success'}))
        }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
            dispatch(handleRemoveDisableSubmitButton('edit_account_receivable'))
            dispatch(handleErrorResponse({"edit_account_receivable": error}))
        });
    }
};

export const fetchAccountConsultantSuccess = (response) => {
    return {
      type: FETCH_ACCOUNT_CONSULTANT_LIST_SUCCESS,
      payload: response
    }
};
  
export const fetchAccountConsultantList = (filterBy={page:1}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        // GET_ACCOUNT_CONSULTANT_LIST
        userService.get(GET_ACCOUNT_CONSULTANT ,filterBy).then((response) => {
            if (response) {
                dispatch(fetchAccountConsultantSuccess(response));
                dispatch(fetchSuccess());
            }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
        });
    }
}

export const fetchConsultantOnOffersSuccess = (response) => {
    return {
      type: FETCH_ACCOUNT_CONSULTANT_ON_OFFERS_LIST_SUCCESS,
      payload: response
    }
};

export const fetchConsultantOnOffersList = (filterBy={consultant: null}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        userService.get(GET_CONSULTANT_ON_OFFERS_LIST ,filterBy).then((response) => {
            if (response) {
                dispatch(fetchConsultantOnOffersSuccess(response));
                dispatch(fetchSuccess());
            }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
        });
    }
}

export const fetchAccountConsultantObjectSuccess = (response) => {
    return {
      type: FETCH_ACCOUNT_CONSULTANT_OBJECT_SUCCESS,
      payload: response
    }
};
  
export const fetchAccountConsultantObject = (filterBy={consultant_id:null}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        const endPoint = GET_ACCOUNT_CONSULTANT_LIST.concat(`?consultant_id=${filterBy.consultant_id}`)
        userService.get(endPoint).then((response) => {
            if (response) {
                dispatch(fetchAccountConsultantObjectSuccess(response));
                dispatch(fetchSuccess());
            }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
        });
    }
}

export const fetchAccountConsultantOffersListSuccess = (offers) => {
    return {
      type: FETCH_ACCOUNT_CONSULTANT_OFFER_LIST_SUCCESS,
      payload: offers
    }
  };
  
  export const fetchAccountConsultantOffersList = (filterBy={page:1, consultant:null}) => {  // this will fetch the ongoing offers of the consultant
    return(dispatch) => {
      dispatch(fetchStart());
      userService.get(GET_ACCOUNT_CONSULTANT_OFFERS, filterBy).then((response) => {
          if (response) {
              dispatch(fetchAccountConsultantOffersListSuccess(response))
            dispatch(fetchSuccess());
          }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
        });
    };
  };

  export const fetchAccountPayrollDetailsSuccess = (offers) => {
    return {
      type: FETCH_ACCOUNT_PAYROLL_DETAILS_SUCCESS,
      payload: offers
    }
  };

  export const resetAccountPayrollDetailsSuccess = () => {
    return {
      type: FETCH_ACCOUNT_PAYROLL_DETAILS_SUCCESS,
      payload: null
    }
  };
  
  export const fetchAccountPayrollDetailsList = (filterBy={consultant:null}) => {
    return(dispatch) => {
      dispatch(fetchStart());
      userService.get(GET_ACCOUNT_PAYROLL_DETAILS, filterBy).then((response) => {
          if (response) {
            dispatch(fetchAccountPayrollDetailsSuccess(response))
            dispatch(fetchSuccess());
          }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
        });
    };
  };


export const fetchOngoingAccountOffersListSuccess = (offers) => {
    return {
        type: FETCH_ONGOING_ACCOUNT_OFFER_LIST_SUCCESS,
        payload: offers
    }
};
export const fetchClosedAccountOffersListSuccess = (offers) => {
    return {
        type: FETCH_CLOSED_ACCOUNT_OFFER_LIST_SUCCESS,
        payload: offers
    }
};

export const fetchAccountsOffersList = (filterBy={ page:1, status:null }) => {  // this will fetch the ongoing offers of the consultant
    return(dispatch) => {
        dispatch(fetchStart());
        userService.get(GET_ALL_OFFERS_EXCLUDING_JOINGING_PENDING, filterBy).then((response) => {
            if (response) {
                if(filterBy.status === 'ongoing'){
                    dispatch(fetchOngoingAccountOffersListSuccess(response))
                }
                if(filterBy.status === 'closed'){
                    dispatch(fetchClosedAccountOffersListSuccess(response))
                }
                dispatch(fetchSuccess());
            }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
        });
    };
};

export const fetchAccountsOffersListByYearSuccess = (offers) => {
  return {
      type: FETCH_ACCOUNT_OFFER_BY_YEAR_LIST_SUCCESS,
      payload: offers
  }
};

export const fetchAccountsOffersListByYear = (filterBy={ year:null }) => {
  return(dispatch) => {
      dispatch(fetchStart());
      userService.get(GET_ACCOUNT_OFFER_BY_YEAR_LIST, filterBy).then((response) => {
        if (response) {
          dispatch(fetchAccountsOffersListByYearSuccess(response))
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
      });
  };
};

export const fetchMissingTimsheetAttachementSuccess = (offers) => {
  return {
      type: FETCH_MISSING_TIMESHEET_LIST_SUCCESS,
      payload: offers
  }
};

export const fetchMissingTimsheetAttachementList = () => {
  return(dispatch) => {
      dispatch(fetchStart());
      userService.get(GET_MISSING_TIMESHEET_LIST).then((response) => {
        if (response) {
          dispatch(fetchMissingTimsheetAttachementSuccess(response))
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
      });
  };
};

export const fetchMissingTimsheetAttachementDetailsSuccess = (offers) => {
  return {
      type: FETCH_MISSING_TIMESHEET_DETAILS_SUCCESS,
      payload: offers
  }
};

export const fetchMissingTimsheetAttachementDetails = (filterBy={offerId:null}) => {
  return(dispatch) => {
      dispatch(fetchStart());
      const endPoint = GET_MISSING_TIMESHEET_DETAILS.replace('offerId',filterBy.offerId)
      userService.get(endPoint).then((response) => {
        if (response) {
          dispatch(fetchMissingTimsheetAttachementDetailsSuccess(response))
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
      });
  };
};


export const editAccountsOffer = (filterBy={offerId: null, value: null, tableType: null, currentFilter: null,
  currentPage: null
}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    const apiEndpoint = EDIT_ACCOUNTS_OFFERS.replace('offerId',filterBy.offerId)
    userService.patch(apiEndpoint, filterBy.value).then((response) => {
      if (response) {
        dispatch(fetchSuccess());
        dispatch(fetchAccountsOffersList({page: filterBy.currentPage, status: filterBy.tableType, 
          ...(filterBy.currentFilter && { ...filterBy.currentFilter })
        }))
        dispatch(handleErrorResponse({"edit_account_offer": "success"}))
      }
    }).catch(function (error) {
      dispatch(handleErrorResponse({"edit_account_offer": error}))
      dispatch(fetchError(error.data.errors));
    });
  }
};

export const fetchAccountOfferConsultantPayeesListSuccess = (response) => {
    return {
        type: FETCH_ACCOUNT_OFFER_CONSULTANT_PAYEE_LIST_SUCCESS,
        payload: response
    }
};

export const fetchAccountOfferConsultantPayeesList = (filterBy={offerId: null}) => {
    return (dispatch) => {
      dispatch(fetchStart());
      const apiEndpoint = GET_ACCOUNT_CONSULTANT_OFFERS_ASSIGNED_PAYEE_LIST.concat(`&offer=${filterBy.offerId}`).concat('&pagination=false')
      userService.get(apiEndpoint).then((response) => {
        if (response) {
          dispatch(fetchAccountOfferConsultantPayeesListSuccess(response));
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
      });
    }
  };

export const resetAccountOfferConsultantPayeesList = () => {
    return (dispatch) => {
        dispatch(fetchAccountOfferConsultantPayeesListSuccess(null));
    }
}

export const GeneratePayroll = (filterBy={value:null ,currentPage:1}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        userService.post(GENERATE_PAYROLL,filterBy.value).then((response) => {
        if (response) {
            dispatch(fetchSuccess());
            message.success("Successful !")
            dispatch(handleRemoveDisableSubmitButton('generate_payroll'))
            dispatch(handleErrorResponse({"generate_payroll": "success"}))
        }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
            if (error && error.data && error.data.offers && Array.isArray(error.data.offers)) {
              error.data.offers.forEach((dataObj) => {
                if (Array.isArray(dataObj.payees)) {
                  dataObj.payees.forEach((payee) => {
                  if (typeof payee === "string") {
                    message.error(`Payee Error: ${payee}`);
                  } else {
                    Object.keys(payee).forEach((key) => {
                      const errorField = payee[key];
                      if (Array.isArray(errorField) && errorField.length > 0) {
                        const errorMessage = errorField[0];
                        message.error(`${key} :- ${errorMessage}`);
                      }
                    });
                  }
                  });
                } 
                else if (typeof dataObj.payees === 'object' && !Array.isArray(dataObj.payees)) {
                  if (dataObj.payees && Object.keys(dataObj.payees).length > 0) {
                    const firstError = dataObj.payees[Object.keys(dataObj.payees)[0]];
                    message.error(firstError);
                  }
                }
                else if (typeof dataObj.payees === 'string') {
                  message.error(dataObj.payees);
                }
              });
            }
            dispatch(handleErrorResponse({"generate_payroll": error}))
            dispatch(handleRemoveDisableSubmitButton('generate_payroll'))
        });
    }
};

export const CreatePayrollCache = (filterBy={value:null, last: null, alternate_email: null}) => {
  const headers = {
    "Content-Type": "multipart/form-data"
   };
  return (dispatch) => {
      userService.post(CREATE_PAYROLL_CACHE,filterBy.value,headers).then((response) => {
      if (response) {
        dispatch(fetchPayrollCacheListSuccess(response));
        if(filterBy.value){
          let keysArray = []
          for (const key of filterBy.value.keys()) {
            if(!["start_date", "end_date", "consultant", "payroll_json","project_type"].includes(key)){
              keysArray.push(key)
            }
          }
          if(keysArray && keysArray.length > 0){
            keysArray.forEach((item)=>{
              const parts = item.split('_');
              if (parts) {
                const [offerId, payee_id, ...payeeType] = parts;
                const payee_type = payeeType && payeeType.slice(0, -2).join('_')
                dispatch(
                  sendConsultantInvoiceAttachemntApproveMail({
                    cache_id: response.id,
                    offerId: offerId,
                    payee_id: payee_id,
                    payeeType: payee_type,
                    ...(filterBy.alternate_email && {alternate_email: filterBy.alternate_email}),
                    ...(filterBy.cc_email && {cc_email: filterBy.cc_email})
                  })
                );
              }
            })
          }
        }
      }
      }).catch(function (error) {
          dispatch(fetchError(error.data.errors));
      });
  }
};

export const sendConsultantInvoiceAttachemntApproveMail = (filterBy={cache_id: null, offerId: null, payee_id: null, payeeType: null, 
  alternate_email: null, cc_email: null
}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    let apiEndpoint = SEND_CONSULTANT_INVOICE_APPROVE_MAIL.replace('cache_id',filterBy.cache_id).replace('payee_id',filterBy.payee_id)
    .replace('offer_id',filterBy.offerId).replace('payeeType',filterBy.payeeType)  
    if(filterBy.alternate_email){
      const hasQueryParams = apiEndpoint.includes('?');
      const encodedEmail = encodeURIComponent(filterBy.alternate_email);
      apiEndpoint += `${hasQueryParams ? '&' : '?'}alternate_email=${encodedEmail}`;
    }
    if(filterBy.cc_email){
      const hasQueryParams = apiEndpoint.includes('?');
      const encodedCcEmail = encodeURIComponent(filterBy.cc_email);
      apiEndpoint += `${hasQueryParams ? '&' : '?'}cc_email=${encodedCcEmail}`;
    }
    userService.patch(apiEndpoint, filterBy.value).then((response) => {
      if (response) {
        dispatch(fetchSuccess());
        message.success('Mail send successfully !')
      }
    }).catch(function (error) {
      message.error('Problem sending approve mail !')
      dispatch(fetchError(error.data.errors));
    });
  }
};

export const fetchPayrollCacheListSuccess = (response) => {
  return {
      type: FETCH_PAYROLL_CACHE_LIST_SUCCESS,
      payload: response
  }
};

export const fetchPayrollCacheList = (filterBy={consultant_id: null, start_date:null, end_date:null}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    // const apiEndpoint = filterBy.consultant_id ? GET_PAYROLL_CACHE.concat(`?consultant_id=${filterBy.consultant_id}`) : GET_PAYROLL_CACHE
      userService.get(GET_PAYROLL_CACHE,filterBy).then((response) => {
      if (response) {
        dispatch(fetchSuccess());
        dispatch(fetchPayrollCacheListSuccess(response));
      }
      }).catch(function (error) {
        if(error && error.status && error.statusText && error.status === 404 && error.statusText === "Not Found"){
          dispatch(fetchPayrollCacheListSuccess(null))
        }
          dispatch(fetchError(error.data.errors));
      });
  }
};

export const fetchAccountHoursListSuccess = (response) => {
    return {
        type: FETCH_APPROVED_HOURS_LIST_SUCCESS,
        payload: response
    }
};

export const fetchApprovedHours = (filterBy={offerId: null, start_date: null, end_date: null}) => {
    return (dispatch) => {
      dispatch(fetchStart());
      const apiEndpoint = GET_APPROVED_HOURS.replace('offerId',filterBy.offerId)
      userService.get(apiEndpoint,filterBy).then((response) => {
        if (response) {
          dispatch(fetchAccountHoursListSuccess(response));
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
      });
    }
  };


export const fetchAccountTransactionListSuccess = (response) => {
    return {
        type: FETCH_TRANSACTION_LIST_SUCCESS,
        payload: response
    }
};

export const fetchTransactionList = (filterBy={page:1, ap_type: null, type: null, consultant_payee: null, 
    support_payee: null, invoice_number: null, start_date: null, end_date: null }) => {
    return (dispatch) => {
      dispatch(fetchStart());
      const apiEndpoint = GET_TRANSACTION_LIST
      userService.get(apiEndpoint,filterBy).then((response) => {
        if (response) {
          dispatch(fetchAccountTransactionListSuccess(response));
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
      });
    }
  };

export const editTransaction = (filterBy={transactionId:null, value:null, currentPage:1, pageSize:null, filters:{},
  fetchListOnResponce:true, updateTableCellOnResponse:(()=>{})
}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        const {filters} = filterBy
        const andPoint = UPDATE_TRANSACTION_LIST.replace('transactionId',filterBy.transactionId)
        // userService.patch(andPoint,filterBy.value).then((response) => {
            userService.patch(andPoint,filterBy.value).then((response) => {
        if (response) {
          dispatch(fetchSuccess());
          if(filterBy.fetchListOnResponce === false && filterBy.updateTableCellOnResponse){
            filterBy.updateTableCellOnResponse()
          }else{
            dispatch(fetchTransactionList({page: filterBy.currentPage ,ap_type: filters.ap_type ,type: filters.type,
              payee: filters.payee ,invoice_number: filters.invoice_number ,start_date: filters.start_date,
              end_date: filters.end_date 
            }));
          }
            dispatch(handleRemoveDisableSubmitButton('edit_transaction'))
            dispatch(showMessage('Successful!'))
            dispatch(handleErrorResponse({"edit_transaction": 'success'}))
            
        }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
            dispatch(handleRemoveDisableSubmitButton('edit_transaction'))
            dispatch(handleErrorResponse({"edit_transaction": error}))
        });
    }
};

export const deleteTransaction = (filterBy={transactionId:null, value:null, currentPage:1, pageSize:null, filters:{}}) => {
    return (dispatch) => {
        dispatch(fetchStart());
        const {filters} = filterBy
        const andPoint = DELETE_TRANSACTION_LIST.replace('transactionId',filterBy.transactionId)
        userService.destroy(andPoint).then((response) => {
        if (response) {
            dispatch(fetchTransactionList({page: filterBy.currentPage ,ap_type: filters.ap_type ,type: filters.type,
                payee: filters.payee ,invoice_number: filters.invoice_number ,start_date: filters.start_date,
                end_date: filters.end_date 
            }));
            dispatch(showMessage('Successful!'))
            dispatch(fetchSuccess());
        }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
        });
    }
};


export const fetchInvoiceListSuccess = (response) => {
    return {
        type: FETCH_INVOICE_NUMBER_LIST_SUCCESS,
        payload: response
    }
};

export const fetchInvoiceNumberList = () => {
    return (dispatch) => {
      dispatch(fetchStart());
      const apiEndpoint = GET_INVOICE_NUMBER_LIST
      userService.get(apiEndpoint).then((response) => {
        if (response) {
          dispatch(fetchInvoiceListSuccess(response));
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
      });
    }
  };

export const fetchTransactionListByInvoiceNumberSuccess = (response) => {
    return {
        type: FETCH_TRANSATION_LIST_FROM_INVOICE_NUMBER,
        payload: response
    }
};

export const fetchTransactionListByInvoiceNumber = (filterBy={invoice_number:null, ap_type:null}) => {
    return (dispatch) => {
      dispatch(fetchStart());
      const apiEndpoint = (filterBy.ap_type === undefined || filterBy.ap_type === null) ? GET_TRANSATION_LIST_FROM_INVOICE_NUMBER.replace('invoice_number',filterBy.invoice_number) 
      :
      GET_TRANSATION_LIST_FROM_INVOICE_NUMBER.replace('invoice_number',filterBy.invoice_number).concat('?ap_type=',filterBy.ap_type) 
      userService.get(apiEndpoint).then((response) => {
        if (response) {
          dispatch(fetchTransactionListByInvoiceNumberSuccess(response));
          dispatch(handleRemoveDisableSubmitButton('download_invoice_pdf'))
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(handleRemoveDisableSubmitButton('download_invoice_pdf'))
        dispatch(fetchError(error.data.errors));
      });
    }
};

export const fetchTransactionListToDownloadSuccess = (response) => {
    return {
        type: FETCH_TRANSATION_LIST_TO_DOWNLOAD,
        payload: response
    }
};

export const fetchTransactionListToDownload = (filterBy={download:true}) => {
    return (dispatch) => {
      dispatch(fetchStart());
    const apiEndpoint = GET_TRANSATION_LIST_TO_DOWNLOAD
      userService.get(apiEndpoint, filterBy).then((response) => {
        if (response) {
          dispatch(fetchTransactionListToDownloadSuccess(response));
          dispatch(handleRemoveDisableSubmitButton('download_invoice_pdf'))
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(handleRemoveDisableSubmitButton('download_invoice_pdf'))
        dispatch(fetchError(error.data.errors));
      });
    }
};

export const addReimbursement = (filterBy={value:null ,currentPage:1}) => {
    const headers = {
        "Content-Type": "multipart/form-data"
       };
    return (dispatch) => {
        dispatch(fetchStart());
        userService.post(ADD_REIMBURSEMENT, filterBy.value, headers).then((response) => {
        if (response) {
            dispatch(fetchSuccess());
            dispatch(handleRemoveDisableSubmitButton('add_reimbursement'))
            dispatch(fetchReimbursementList({page: filterBy.currentPage}));
            dispatch(showMessage('Successful!'))
            dispatch(handleErrorResponse({"add_reimbursement": "success"}))
        }
        }).catch(function (error) {
            dispatch(fetchError(error.data.errors));
            dispatch(handleRemoveDisableSubmitButton('add_reimbursement'))
            dispatch(handleErrorResponse({"add_reimbursement": error}))
        });
    }
};

export const fetchReimbursementSuccess = (response) => {
    return {
        type: FETCH_REIMBURSEMENT_LIST_SUCCESS,
        payload: response
    }
};

export const fetchReimbursementList = (filterBy={page:1}) => {
    return (dispatch) => {
      dispatch(fetchStart());
      userService.get(ADD_REIMBURSEMENT,filterBy).then((response) => {
        if (response) {
          dispatch(fetchReimbursementSuccess(response));
          dispatch(fetchSuccess());
        }
      }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
      });
    }
  };

export const editReimbursement = (filterBy={value:null ,reimbursementId:null, currentPage:1,
  updateTableCellOnResponse:(()=>{}), fetchListOnResponce: true
}) => {
    const headers = { "Content-Type": "multipart/form-data" };
    return (dispatch) => {
      dispatch(fetchStart());
    var endPoint = Edit_REIMBURSEMENT.replace('reimbursementId',filterBy.reimbursementId)
      userService.patch(endPoint, filterBy.value, headers).then((response)=>{
        if (response) {
          dispatch(fetchSuccess());
          if(filterBy.fetchListOnResponce === false ){
            if(filterBy.updateTableCellOnResponse){
              filterBy.updateTableCellOnResponse()
            }
          }else{
            dispatch(fetchReimbursementList({page: filterBy.currentPage}));
            dispatch(handleRemoveDisableSubmitButton('edit_reimbursement'))
            dispatch(handleErrorResponse({"edit_reimbursement": "success"}))
          }
        }
      }).catch((error)=>{
        dispatch(fetchError(error.data.errors));
        dispatch(handleRemoveDisableSubmitButton('edit_reimbursement'))
        dispatch(handleErrorResponse({"edit_reimbursement": error}))
      })
    }
}
  
export const updateReimbursementStatus = (filterBy={value:null, reimbursementId:null, updateTableCellOnResponse:(()=>{})}) => {
    return (dispatch) => {
      dispatch(fetchStart());
    var endPoint = Edit_REIMBURSEMENT_STATUS.replace('reimbursementId',filterBy.reimbursementId)
      userService.patch(endPoint, filterBy.value).then((response)=>{
        if (response) {
          dispatch(fetchSuccess());
          if(filterBy.updateTableCellOnResponse){
            filterBy.updateTableCellOnResponse()
          }
        }
      }).catch((error)=>{
        dispatch(fetchError(error.data.errors));
      })
    }
}
  
export const fetchAccountSupportOffersListSuccess = (offers) => {
    return {
      type: FETCH_ACCOUNT_SUPPORT_OFFER_LIST_SUCCESS,
      payload: offers
    }
};
  
export const fetchAccountSupportOffersList = (filterBy={page:1, support_id:null}) => {
  return(dispatch) => {
    dispatch(fetchStart());
    let endPoint = GET_ACCOUNT_SUPPORT_OFFERS.replace('support_id',filterBy.support_id)
    delete filterBy.support_id
    userService.get(endPoint, filterBy).then((response) => {
      if (response) {
        dispatch(fetchAccountSupportOffersListSuccess(response))
        dispatch(fetchSuccess());
      }
    }).catch(function (error) {
        dispatch(fetchError(error.data.errors));
    });
};
};

  